import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RedditIcon(props: IconProps) {
    return <Icon {...props} iconKey={"reddit"}/>
}
